var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.904 1.78181V4.72605C50.9029 5.3107 50.4294 5.78423 49.8448 5.78523H1.96317C1.37852 5.78416 0.904995 5.31067 0.903992 4.72605V1.78181C0.904704 1.19716 1.37855 0.723357 1.96317 0.722992H49.8448C50.4295 0.723348 50.9033 1.19719 50.904 1.78181V1.78181ZM49.8448 31.0993H1.96317C1.37852 31.1003 0.904995 31.5738 0.903992 32.1584V35.1027C0.905061 35.687 1.37855 36.1609 1.96317 36.1615H49.8448C50.4295 36.1608 50.903 35.6869 50.904 35.1027V32.1584C50.9029 31.5738 50.4294 31.1003 49.8448 31.0993ZM49.8448 15.9106H1.96317C1.37852 15.9117 0.904995 16.3852 0.903992 16.9698V19.914C0.905061 20.4987 1.37855 20.9722 1.96317 20.9732H49.8448C50.4295 20.9722 50.903 20.4987 50.904 19.914V16.9698C50.9029 16.3852 50.4294 15.9116 49.8448 15.9106V15.9106Z",
    fill: "#6BAE61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBars);
export default __webpack_public_path__ + "static/media/menu-bars.3738074426805438300e6e30d094210e.svg";
export { ForwardRef as ReactComponent };